import { render, staticRenderFns } from "./ResiDetail.vue?vue&type=template&id=fff396b0&"
import script from "./ResiDetail.vue?vue&type=script&lang=js&"
export * from "./ResiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports